import React, { memo } from 'react';

import cx from 'classnames';

import { Badge } from '../badges/Badge';
import type { QuestionRowViewModel } from '../../viewmodels/createQuestionRowViewModel';
import { ResponseTypeCell } from './ResponseTypeCell';

import styles from './QuestionTable.scss';

type Props = {
  viewModel: QuestionRowViewModel;
};

export const QuestionRow = memo(function QuestionRow({ viewModel }: Props) {
  return (
    <div role="row" className={styles.row} data-test="question-row">
      <div role="cell" className={styles.questionCell}>
        {viewModel.badges.map(badge => (
          <Badge key={badge.kind} viewModel={badge} />
        ))}
        <span className={cx(viewModel.isHidden && styles.hidden)}>
          {viewModel.label}
        </span>
      </div>
      <ResponseTypeCell viewModel={viewModel.responseType} />
    </div>
  );
});
